import { config } from '../../config';
import { IntercomService } from '@gig/magic-messaging/dist/components/intercom';

export const intercom: IntercomService | null = config.intercom
    ? new IntercomService(config.intercom)
    : null;
